export const formatDateTimeLocal = (dateString: string) => {
  if (!dateString) {
    return "";
  }

  const date = new Date(dateString);
  if (Number.isNaN(date.getTime())) {
    return "";
  }

  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  const hours = String(date.getHours()).padStart(2, "0");
  const minutes = String(date.getMinutes()).padStart(2, "0");

  return `${year}-${month}-${day}T${hours}:${minutes}`;
};

export const formatDateTimeLocalDisplay = (dateString: string) => {
  if (!dateString) {
    return "";
  }

  const date = new Date(dateString);
  if (Number.isNaN(date.getTime())) {
    return "";
  }

  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  const year = date.getFullYear();
  const hours = date.getHours();
  const displayHours = hours % 12 || 12;
  const minutes = String(date.getMinutes()).padStart(2, "0");
  const meridiem = hours >= 12 ? "PM" : "AM";

  return `${month}-${day}-${year} ${String(displayHours).padStart(2, "0")}:${minutes} ${meridiem}`;
};

export const toApiDateTime = (dateString: string) => {
  const date = new Date(dateString);
  return Number.isNaN(date.getTime()) ? "" : date.toISOString();
};

const parseStartDate = (dateString: string) => {
  const date = new Date(dateString);
  if (Number.isNaN(date.getTime())) {
    return null;
  }

  date.setSeconds(0, 0);
  return date;
};

const parseEndDate = (dateString: string) => {
  const date = new Date(dateString);
  if (Number.isNaN(date.getTime())) {
    return null;
  }

  date.setSeconds(59, 999);
  return date;
};

export const isBannerActive = (banner, currentTime = new Date()) => {
  const start = parseStartDate(banner?.startDate);
  const end = parseEndDate(banner?.endDate);

  if (!start || !end) {
    return false;
  }

  return currentTime >= start && currentTime <= end;
};

export const getActiveBanners = (banners = [], currentTime = new Date()) => {
  return banners.filter((banner) => isBannerActive(banner, currentTime));
};
